// bibliotecas externas
import React, { useEffect, useState } from "react";
import { Badge, Card, CardBody } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// context
import { MatchContext } from "../providers/match";

// services
import { checkRoom } from "../utils/services/roommates";

// store
import { reset } from "../store/users";

// nomes dos grupos (em minúsculo) correspondentes a cada tamanho de quarto
const ROOM_TYPE_LABELS = {
  2: "duplo",
  3: "triplo",
  4: "quadruplo",
};

function CardRoomType({
  labelText,
  id,
  roomSize,
  part,
  setAvailableRooms,
  group,
}) {
  const navigate = useNavigate();
  const {
    t,
    i18n,
    setNewContextRefresh,
    setRoomSize,
    setTypeOfRoom,
    matchConfig,
  } = React.useContext(MatchContext);
  const store = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // state de disponibilidade do tipo de quarto
  const [enabled, setEnabled] = useState(false);
  // state de verificação concluída (evita mostrar o card antes de saber se está disponível)
  const [checked, setChecked] = useState(false);

  // verifica se o participante já está restrito a outro tipo de quarto pelos grupos; se não estiver, consulta a disponibilidade na API
  function verifyShow() {
    const currentLabel = ROOM_TYPE_LABELS[roomSize];
    const hasCurrentType = group?.find(
      (e) => e.name.toLocaleLowerCase() === currentLabel,
    );
    const hasOtherType = group?.find((e) => {
      const name = e.name.toLocaleLowerCase();
      return (
        name !== currentLabel && Object.values(ROOM_TYPE_LABELS).includes(name)
      );
    });

    if (!hasCurrentType && hasOtherType) {
      setEnabled(false);
      setChecked(true);
      return;
    }
    getRoomStatus();
  }

  // consulta a disponibilidade de vagas para este tipo de quarto e atualiza os states de habilitado/verificado
  const getRoomStatus = () => {
    checkRoom({
      eventID: id,
      size: roomSize,
    })
      .then((r) => {
        if (r.full === false) {
          setEnabled(true);
          setAvailableRooms(true);
        } else {
          setEnabled(false);
        }
        setChecked(true);
      })
      .catch(() => {
        setEnabled(false);
        setChecked(true);
      });
  };

  // navega para a tela de match com os parâmetros do quarto escolhido
  const goToMatch = () => {
    setNewContextRefresh();
    dispatch(reset([]));
    setRoomSize(roomSize);
    setTypeOfRoom(roomSize);
    navigate({
      pathname: "/match",
      search: `?idEvent=${id}&idPart=${part}&room=${roomSize}&idiom=${i18n.language}`,
    });
  };

  useEffect(() => {
    if (!group) return;

    if (group?.length > 0) {
      verifyShow();
    } else getRoomStatus();
  }, [group]);

  if (!checked || !enabled) return null;

  return (
    <Card
      className={`card-room-item-main`}
      style={{
        cursor: "pointer",
      }}
      onClick={goToMatch}
    >
      <CardBody className="room-item-body">
        <div className="room-item-icon">
          <i
            className="fa-solid fa-bed"
            style={{ color: matchConfig?.colorBackground }}
          ></i>
        </div>
        <div className="room-item-info">
          <span className="room-item-label" style={{ color: "#495057" }}>
            {labelText}
          </span>
          <span className="room-item-capacity">
            {roomSize} {t("pessoas")}
          </span>
        </div>
        <Badge className="room-item-badge" color={"success"}>
          {t("Disponível")}
        </Badge>
        <i className="fa-solid fa-chevron-right room-item-chevron"></i>
      </CardBody>
    </Card>
  );
}
export default CardRoomType;
